import Vue from 'vue'
import { Lazyload } from 'vant';
import App from './App.vue'
import store from './store'
import router from './router'
Vue.config.productionTip = false
Vue.use(Lazyload, {
  lazyComponent: true,
});
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
